module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "showSmallScreenOnly",
    class: _vm.colorBottomButton
  }, [(_vm.currentRole === 'simple') ? _c('f7-fab', {
    staticClass: "leftfav button-fab bottomButton floatingButtonToolbarBlank",
    on: {
      "click": _vm.addUser
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentRole === 'group') ? _c('f7-fab', {
    staticClass: "leftfav button-fab bottomButton floatingButtonToolbarBlank",
    on: {
      "click": _vm.addGroupMember
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "subNavTitle": _vm.BusinessMembersListLabel,
      "menuAccess": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row rowBackgroundImage",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "row showLargeScreenOnly rowSearchBar"
  }, [(_vm.currentRole === 'simple') ? _c('div', {
    staticClass: "col-md firstButtonMarginLeft"
  }, [_c('button', {
    staticClass: "new-button milkyBlock boxRequest",
    on: {
      "click": _vm.addUser
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('businessMembers.add_member')))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentRole === 'group') ? _c('div', {
    staticClass: "col-md firstButtonMarginLeft"
  }, [_c('button', {
    staticClass: "new-button milkyBlock boxRequest",
    on: {
      "click": _vm.addGroupMember
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('businessMembers.add_team')))])], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "contactButtonContainer",
    class: _vm.colorBottomButton
  }, [_c('f7-grid', {
    attrs: {
      "no-gutter": ""
    }
  }, [_c('f7-col', {
    staticClass: "pilotageTabController",
    attrs: {
      "width": "50"
    }
  }, [(_vm.currentRole === 'simple') ? _c('f7-link', {
    staticClass: "pilotageLink",
    class: _vm.getColor,
    attrs: {
      "tab-link": ".membersTab1",
      "active": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentRole('simple')
      }
    }
  }, [_vm._v("Members")]) : _c('f7-link', {
    staticClass: "pilotageLink",
    attrs: {
      "tab-link": ".membersTab1",
      "active": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentRole('simple')
      }
    }
  }, [_vm._v("Members")])], 1), _vm._v(" "), _c('f7-col', {
    staticClass: "pilotageTabController",
    attrs: {
      "width": "50"
    }
  }, [(_vm.currentRole === 'group') ? _c('f7-link', {
    staticClass: "pilotageLink",
    class: _vm.getColor,
    attrs: {
      "tab-link": ".membersTab2"
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentRole('group')
      }
    }
  }, [_vm._v("Teams")]) : _c('f7-link', {
    staticClass: "pilotageLink",
    attrs: {
      "tab-link": ".membersTab2"
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentRole('group')
      }
    }
  }, [_vm._v("Teams")])], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('f7-tabs', [_c('f7-tab', {
    staticClass: "membersTab1",
    attrs: {
      "active": ""
    }
  }, [_c('f7-searchbar', {
    staticClass: "members-sb webdatalist",
    attrs: {
      "id": "members-sb",
      "cancel-link": "Cancel",
      "search-list": "#members-list",
      "placeholder": "Search in Members",
      "found": ".members-found"
    },
    on: {
      "searchbar:search": _vm.onSearch,
      "searchbar:clear": _vm.onClear
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layoutSubtitle"
  }), _vm._v(" "), _c('f7-list', {
    staticClass: "searchbar-not-found"
  }, [_c('f7-list-item', {
    attrs: {
      "title": "Nothing found"
    }
  })], 1), _vm._v(" "), _c('f7-list', {
    staticClass: "members-found",
    attrs: {
      "id": "members-list"
    }
  }, [_c('cm-account-membersList-list', {
    attrs: {
      "userAccounts": _vm.userAccounts,
      "filterBy": _vm.filterBy
    }
  })], 1)], 1), _vm._v(" "), _c('f7-tab', {
    staticClass: "membersTab2"
  }, [_c('f7-searchbar', {
    staticClass: "webdatalist",
    attrs: {
      "cancel-link": "Cancel",
      "search-list": "#group-list",
      "placeholder": "Search in Teams"
    },
    on: {
      "searchbar:search": _vm.onTeamSearch,
      "searchbar:clear": _vm.onTeamSearchClear
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layoutSubtitle"
  }), _vm._v(" "), _c('f7-list', {
    staticClass: "searchbar-not-found"
  }, [_c('f7-list-item', {
    attrs: {
      "title": "Nothing found"
    }
  })], 1), _vm._v(" "), _c('f7-list', {
    staticClass: "group-found",
    attrs: {
      "id": "group-list"
    }
  }, [_c('cm-members-group-list', {
    attrs: {
      "membersGroup": _vm.membersGroup,
      "filterBy": _vm.teamFilterBy
    }
  })], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3fbbe86b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fbbe86b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/accounts/CMAccountMembersPage.vue
// module id = 1660
// module chunks = 2